import { render, staticRenderFns } from "./auth-form.vue?vue&type=template&id=1f517ee0&scoped=true&"
import script from "./auth-form.vue?vue&type=script&lang=js&"
export * from "./auth-form.vue?vue&type=script&lang=js&"
import style0 from "./auth-form.vue?vue&type=style&index=0&id=1f517ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f517ee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
